import { render, staticRenderFns } from "./user-show-history.vue?vue&type=template&id=6287d1f1&scoped=true&"
import script from "./user-show-history.vue?vue&type=script&lang=js&"
export * from "./user-show-history.vue?vue&type=script&lang=js&"
import style0 from "./user-show-history.vue?vue&type=style&index=0&id=6287d1f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287d1f1",
  null
  
)

export default component.exports